/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import PropTypes from 'prop-types';
import { CampagnaPianiValore } from '../domain/eccellenza/eccellenza';

export const TipoCardPianiValore = {
  Eccellenza: {
    name: 'eccellenza',
    image: {
      src: '/images/Eccellenza.svg',
      alt: 'Servizio eccellenza',
    },
    showInfoPianiValore: true,
  },
  Unicita: {
    name: 'unicita',
    image: {
      src: '/images/Unicita.png',
      style: { width: '148px' },
      alt: 'Servizio unicita',
    },
    showInfoPianiValore: false,
  },
};

/**
*/
export default function CardPianiValore({ messaggio, tipo }) {
  const className = `helpdesk-frontend-card-piani_valore__section helpdesk-frontend-card-piani_valore__section--${tipo.name}`;
  return (
    <section className={className}>
      <img {...tipo.image} />
      <section className="helpdesk-frontend-card-piani_valore__message small-text-regular">
        {messaggio}

        {tipo.showInfoPianiValore && (
          <p>
            Scopri di più sulle altre funzioni e sui&nbsp;<a href={CampagnaPianiValore} target="__blank">Piani di Valore CGN</a>
          </p>
        )}
      </section>
    </section>
  );
}

CardPianiValore.propTypes = {
  messaggio: PropTypes.element.isRequired,
  tipo: PropTypes.oneOf(Object.values(TipoCardPianiValore)).isRequired,
};

CardPianiValore.defaultProps = {
};
